import * as yup from 'yup';

import { propertyContractBaseSchema } from '@/features/Contract/Property/contractBaseSchema';
import { usePfeInputStore } from '@/features/Sparten/pfe/useInputStore';
import { locales } from '@/features/validation/locales';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { testSpecialChars } from '@/utils/strings/strings';
import { GENDER } from '@/features/Clients/genderTypes';

yup.setLocale(locales);

export const horseSchema = yup.object({
  name: yup.string().required().default('').test(testSpecialChars),
  rasse: yup.string().required().default('').test(testSpecialChars),
  farbe: yup.string().required().default('').test(testSpecialChars),
  alter: yup.string().required().default('0'),
  geschlecht: yup.string().required().default(GENDER.MALE),
});

export const reitbeteiligungenSchema = yup.object({
  art: yup.string().required().default('').test(testSpecialChars),
  name: yup.string().required().default('').test(testSpecialChars),
});

const pfeHorseInputSchema = yup.object({
  reitvereinsname: yup
    .string()
    .default('')
    .when({
      is: () => usePfeInputStore().reitverein,
      then: yup.string().required(),
    })
    .test(testSpecialChars),
  fremdnutzerAnzahl: yup.number().required().default(0),
  pferde: yup.array().required().of(horseSchema),
  reitbeteiligungen: yup
    .array()
    .ensure()
    .required()
    .of(reitbeteiligungenSchema),
});

export const contractSchema = pfeHorseInputSchema.concat(
  propertyContractBaseSchema,
);

export type ContractStore = yup.Asserts<typeof contractSchema>;
export type Horse = yup.Asserts<typeof horseSchema>;
export type Reitbeteiligung = yup.Asserts<typeof reitbeteiligungenSchema>;

export const usePfeContractStore = genericStoreFactory(
  () => contractSchema.getDefault() as ContractStore,
  'PfeContractStore',
);
